import block from './block.json';

export const paragraphThemeAttributes = {
	color: '@tokens.variants.default.contentColor',
	typography: '@tokens.typographies.paragraph',
	textAlignment: 'left',
};

export const ParagraphThemeControls: ThemeControlsType = {
	// name of the block
	title: block.title,

	// slug of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: paragraphThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
